import { get } from 'lodash';

import Model from 'models';

const PageSectionBodyCardModel = class extends Model {
  get type() {
    return get(this._data, '_contentType');
  }

  get contentMarkdown() {
    return get(this._data, 'contentMarkdown');
  }

  get internalName() {
    return get(this._data, 'internalName');
  }

  get desktopImage() {
    return get(this._data, 'desktopImage');
  }
  get mobileImage() {
    return get(this._data, 'mobileImage');
  }
};

export default PageSectionBodyCardModel;
